import { render } from "./buyInfoMode.vue?vue&type=template&id=39c81fd0&scoped=true"
import script from "./buyInfoMode.vue?vue&type=script&lang=js"
export * from "./buyInfoMode.vue?vue&type=script&lang=js"

import "./buyInfoMode.vue?vue&type=style&index=0&id=39c81fd0&scoped=true&lang=scss"

import exportComponent from "/www/wwwroot/manga-official-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39c81fd0"]])

export default __exports__